export enum MenuContext {
  CATEGORIES = 'categories',
  CMS = 'cms',
  MAIN = 'main',
}

export interface HeaderMenuProps {
  menuContext: MenuContext | null;
  menuItems: MenuItem[];
  toggle: (context: MenuContext | null) => void;
}

export interface HeaderNavigationProps {
  isOpen: boolean;
  toggle: (context: MenuContext) => void;
}

export interface MainMenu {
  key: string;
  label: string;
  openMenu: boolean;
  url: string;
}

export interface MenuItem {
  action?: () => void;
  children: MenuItem[];
  key: string;
  label: string;
  url: string | undefined;
}

export interface NavigationItem {
  key: string;
  label: string | null;
  openMenu: boolean;
  url: string;
}
